import React, { useEffect } from 'react';
import '../styles/casino.css';

const ReddyAnnaHorseRacePage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const message = "Need Cricket ID";
  const encodedMessage = encodeURIComponent(message);
  const ContactLink = `https://wa.me/918977772819?text=${encodedMessage}`;
  const whatsappLink = `https://wa.me/918977772819?text=${encodedMessage}`;
  return (
    <div className="casino-betting-page">
  <div className="casino-betting-intro">
    <div className="casino-betting-intro-content">
      <h1><span>Reddy Anna Casino:</span> Experience Ultimate Gaming Thrills</h1>
      <p>
        Welcome to Reddy Anna Casino, where sophistication and excitement meet. Immerse yourself in a luxurious gaming world that offers a wide array of games, each designed to keep you on the edge of your seat. With world-class features, exclusive lobbies, and engaging live dealer experiences, Reddy Anna Casino takes online gaming to an entirely new level.
      </p>
      <div className="casino-betting-cta-buttons">
        <a href={whatsappLink} className="contactus-button" target="_blank" rel="noopener noreferrer">
          Open Your Demo Account
        </a>
        <a href={ContactLink} className="contactus-button" target="_blank" rel="noopener noreferrer">
          Contact Us Now
        </a>
      </div>
    </div>

    <div className="casino-betting-intro-image">
      <img src="/casino.webp" alt="Casino Gaming" />
    </div>
  </div>

  <section className="casino-betting-features">
    <h2>Explore the Premium <span>Reddy Anna Casino Experience</span></h2>
    <p>
      Reddy Anna Casino offers a selection of exclusive, opulent gaming lobbies designed to cater to the tastes of every player. Each lobby brings its own special vibe, from the fast-paced action in the Bet Games Lobby to the classic sophistication of Baccarat. Whether you're new to the world of online casinos or a seasoned veteran, our lobbies provide an environment that's both exciting and luxurious.
    </p>
    <ol>
      <li>
        <strong>Exciting Casino Games:</strong> Explore a vast collection of thrilling games at Reddy Anna Casino. Play iconic classics like Poker, Roulette, and Blackjack, or try something new with games like Dragon Tiger and the action-packed Vivo Lobby. The options are endless, with something for every taste.
      </li>
      <li>
        <strong>Live Dealer Interaction:</strong> Experience the thrill of a real casino with our live dealer games. Interact with professional dealers in real-time, bringing the excitement of live Baccarat, Poker, and Blackjack directly to you from the comfort of your home.
      </li>
      <li>
        <strong>Easy Navigation:</strong> Whether you're a beginner or an expert, our intuitive platform allows for effortless navigation. Discover new games, explore various lobbies, and start playing instantly with just a few simple clicks.
      </li>
      <li>
        <strong>Secure Transactions:</strong> At Reddy Anna Casino, we prioritize your safety. Using advanced encryption protocols, we ensure your financial details remain secure and private, giving you peace of mind as you play.
      </li>
      <li>
        <strong>Commitment to Responsible Gaming:</strong> We value responsible gaming and encourage players to enjoy gaming in moderation. Set your own limits, stay within your budget, and experience the thrill of gaming with a responsible mindset.
      </li>
    </ol>
  </section>

  <section className="casino-betting-getting-started">
    <h2><span>Reddy Anna</span> | Your Trusted Support Team</h2>
    <p>
      At Reddy Anna Casino, we're committed to providing an unmatched level of support. If you have any questions or need assistance, our customer service team is always ready to assist you. Whether you're a new player or an experienced gamer, we are here to ensure you have a smooth and enjoyable gaming journey.
    </p>
    <p>
      Step into a world of luxury and excitement at Reddy Anna Casino. Join today and take your gaming experience to the next level!
    </p>
  </section>

  <section className="casino-betting-join">
    <h2>Join <span>Reddy Anna</span> Today!</h2>
    <p>
      Ready to begin your journey with Reddy Anna Casino? Join now to enjoy the finest in online gaming, with a user-friendly interface, exciting games, and dedicated customer service. Play responsibly, and let the fun begin!
    </p>
    <div className="casino-betting-cta-buttons">
      <a href={ContactLink} className="contactus-button" target="_blank" rel="noopener noreferrer">
        Open Your Demo Account
      </a>
      <a href={ContactLink} className="contactus-button" target="_blank" rel="noopener noreferrer">
        Contact Us Now
      </a>
    </div>
  </section>
</div>

  );
};

export default ReddyAnnaHorseRacePage;
